import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { isNullish } from '@blaze-shared/shared-util';

import { migrateFontBoldStyleToFontWeightMutably } from '../../../services/compat/migration.helpers';
import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const singleChartV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Single Chart to version 2',
  run: (props: PartialPropsOf<'chartSingle'>): void => {
    props.version ??= 1;
    if (props.version < 2) {
      props.style = {
        ...props.style,
        general: {
          ...props.style?.general,
          description: props.style?.general?.title ?? {
            color1: '$t.title',
            selectorType: 'solid',
          },
        },
      };
      props.version = 2;
    }
    migrateFontBoldStyleToFontWeightMutably(props?.style?.valueFont);

    const { content } = props;
    const titleUpdates: Record<string, any> = {};
    const titleBlockUpdates: Record<string, any> = {};

    if (!isNullish(content?.chart?.title)) {
      titleUpdates.label = content.chart.title;
      delete content.chart.title;
    }

    if (!isNullish(content?.chart?.description)) {
      titleUpdates.description = content.chart.description;
      delete content.chart.description;
    }

    /**
     * Migrate bold style to font weight property
     */
    if (content?.font?.style?.includes('bold')) {
      titleBlockUpdates.fontWeight = '700';
      content.font.style = content.font.style.filter((style) => style !== 'bold');
    }

    if ([titleUpdates, titleBlockUpdates].some((updates) => Object.keys(updates).length)) {
      props.content = {
        ...props.content,
        title: {
          ...props.content?.title,
          ...titleUpdates,
        },
      };
      props.style = {
        ...props.style,
        titleBlock: {
          ...props.style?.titleBlock,
          ...titleBlockUpdates,
        },
      };
    }
  },
};
